module.exports = __webpack_public_path__ + "assets/img/77.39a42a44.jpg";